import { jsx as v } from "react/jsx-runtime";
import { isDefined as t } from "./types3.mjs";
import { NumericFormat as C } from "./react-number-format.es.mjs";
import { createIsAllowed as w } from "./createIsAllowed.mjs";
import { forwardRef as I } from "react";
const x = (e, o, a, n, m, l, u, i) => I(
  (c, f) => {
    const { onChange: s, name: r, value: p, ...d } = c, g = t(e) || t(o) ? w(e, o) : void 0;
    return /* @__PURE__ */ v(
      C,
      {
        ...d,
        value: p ?? "",
        getInputRef: f,
        onValueChange: (h) => {
          s({
            target: {
              name: r,
              value: h.value
            }
          });
        },
        thousandSeparator: a,
        valueIsNumericString: !0,
        name: r,
        isAllowed: g,
        allowLeadingZeros: n,
        decimalScale: m,
        allowNegative: l,
        decimalSeparator: u,
        suffix: i
      }
    );
  }
);
export {
  x as createNumericFormatComponent
};
//# sourceMappingURL=createNumericFormatComponent.mjs.map
